// ##############################
// // // Function that converts from hex color to rgb color
// // // Example: input = #9c27b0 => output = 156, 39, 176
// // // Example: input = 9c27b0 => output = 156, 39, 176
// // // Example: input = #999 => output = 153, 153, 153
// // // Example: input = 999 => output = 153, 153, 153
// #############################
const hexToRgb = (input) => {
    input = input + '';
    input = input.replace('#', '');
    const hexRegex = /[0-9A-Fa-f]/g;
    if (!hexRegex.test(input) || (input.length !== 3 && input.length !== 6)) {
        throw new Error('input is not a valid hex color.');
    }
    if (input.length === 3) {
        const first = input[0];
        const second = input[1];
        const last = input[2];
        input = first + first + second + second + last + last;
    }
    input = input.toUpperCase(input);
    const first = input[0] + input[1];
    const second = input[2] + input[3];
    const last = input[4] + input[5];
    return parseInt(first, 16) + ', ' + parseInt(second, 16) + ', ' + parseInt(last, 16);
};

// ##############################
// // // Variables - Styles that are used on more than one component
// #############################

const transition = {
    transition: 'all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)',
};

const container = {
    'paddingRight': '15px',
    'paddingLeft': '15px',
    'marginRight': 'auto',
    'marginLeft': 'auto',
    '@media (min-width: 768px)': {
        width: '750px',
    },
    '@media (min-width: 992px)': {
        width: '970px',
    },
    '@media (min-width: 1200px)': {
        width: '1170px',
    },
    '&:before,&:after': {
        display: 'table',
        content: '" "',
    },
    '&:after': {
        clear: 'both',
    },
};

const defaultFont = {
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    fontWeight: '300',
    lineHeight: '1.5em',
};

const primaryColor = ['#4caf50', '#72c74c', '#4caf50', '#6ccf6a', '#087f23'];
const dangerColor = ['#f44336', '#ef5350', '#e53935', '#f55a4e', '#d32f2f', '#ebcccc', '#f2dede'];
const warningColor = ['#ff9800', '#ffa726', '#fb8c00', '#ffa21a', '#f57c00', '#faf2cc', '#fcf8e3'];
const successColor = ['#4caf50', '#66bb6a', '#43a047', '#5cb860', '#388e3c', '#d0e9c6', '#dff0d8'];
const infoColor = ['#00acc1', '#26c6da', '#00acc1', '#00d3ee', '#0097a7', '#c4e3f3', '#d9edf7'];
const dashboardColor = ['#4caf50', '#72c74c', '#4caf50', '#6ccf6a', '#087f23'];
const leadsColor = ['#2196f3', '#14b6db', '#2196f3', '#6ec6ff', '#0069c0'];
const fahrzeugeColor = ['#2e7d32', '#4c942f', '#2e7d32', '#60ad5e', '#005005'];
const kundenColor = ['#e53935', '#fc4f2d', '#e53935', '#ff6f60', '#ab000d'];
const einstellungenColor = ['#9c27b0', '#c722a2', '#9c27b0', '#d05ce3', '#6a0080'];
const qrColor = ['#ff9800', '#ffc03c', '#ff9800', '#ffc947', '#c66900'];
const internColor = ['#000000', '#666666', '#333333', '#aaaaaa', '#222222'];
const supportColor = ['#4caf50', '#72c74c', '#4caf50', '#6ccf6a', '#087f23'];
const greyColor = [
    '#999',
    '#777',
    '#3C4858',
    '#AAAAAA',
    '#D2D2D2',
    '#DDD',
    '#555555',
    '#333',
    '#eee',
    '#ccc',
    '#e4e4e4',
    '#E5E5E5',
    '#f9f9f9',
    '#f5f5f5',
    '#495057',
    '#e7e7e7',
    '#212121',
    '#c8c8c8',
    '#505050',
];
const blackColor = '#000';
const whiteColor = '#FFF';

const rateGreenColor = '#4caf50';
const rateLightGreenColor = '#8bc34a';
const rateYellowColor = '#fbc02d';
const rateOrangeColor = '#ff8f00';
const rateRedColor = '#f44336';

const twitterColor = '#55acee';
const facebookColor = '#3b5998';
const googleColor = '#dd4b39';
const linkedinColor = '#0976b4';
const pinterestColor = '#cc2127';
const youtubeColor = '#e52d27';
const tumblrColor = '#35465c';
const behanceColor = '#1769ff';
const dribbbleColor = '#ea4c89';
const redditColor = '#ff4500';

const boxShadow = {
    boxShadow: '0 10px 30px -12px rgba(' + hexToRgb(blackColor) + ', 0.42), 0 4px 25px 0px rgba(' + hexToRgb(blackColor) + ', 0.12), 0 8px 10px -5px rgba(' + hexToRgb(blackColor) + ', 0.2)',
};

const primaryBoxShadow = {
    boxShadow: '0 4px 20px 0 rgba(' + hexToRgb(blackColor) + ',.14), 0 7px 10px -5px rgba(' + hexToRgb(primaryColor[0]) + ',.4)',
};
const infoBoxShadow = {
    boxShadow: '0 4px 20px 0 rgba(' + hexToRgb(blackColor) + ',.14), 0 7px 10px -5px rgba(' + hexToRgb(infoColor[0]) + ',.4)',
};
const successBoxShadow = {
    boxShadow: '0 4px 20px 0 rgba(' + hexToRgb(blackColor) + ',.14), 0 7px 10px -5px rgba(' + hexToRgb(successColor[0]) + ',.4)',
};
const warningBoxShadow = {
    boxShadow: '0 4px 20px 0 rgba(' + hexToRgb(blackColor) + ',.14), 0 7px 10px -5px rgba(' + hexToRgb(warningColor[0]) + ',.4)',
};
const dangerBoxShadow = {
    boxShadow: '0 4px 20px 0 rgba(' + hexToRgb(blackColor) + ',.14), 0 7px 10px -5px rgba(' + hexToRgb(dangerColor[0]) + ',.4)',
};
const dashboardBoxShadow = {
    boxShadow: '0 4px 20px 0 rgba(' + hexToRgb(blackColor) + ',.14), 0 7px 10px -5px rgba(' + hexToRgb(dashboardColor[0]) + ',.4)',
};
const leadsBoxShadow = {
    boxShadow: '0 4px 20px 0 rgba(' + hexToRgb(blackColor) + ',.14), 0 7px 10px -5px rgba(' + hexToRgb(leadsColor[0]) + ',.4)',
};
const fahrzeugeBoxShadow = {
    boxShadow: '0 4px 20px 0 rgba(' + hexToRgb(blackColor) + ',.14), 0 7px 10px -5px rgba(' + hexToRgb(fahrzeugeColor[0]) + ',.4)',
};
const kundenBoxShadow = {
    boxShadow: '0 4px 20px 0 rgba(' + hexToRgb(blackColor) + ',.14), 0 7px 10px -5px rgba(' + hexToRgb(kundenColor[0]) + ',.4)',
};
const einstellungenBoxShadow = {
    boxShadow: '0 4px 20px 0 rgba(' + hexToRgb(blackColor) + ',.14), 0 7px 10px -5px rgba(' + hexToRgb(einstellungenColor[0]) + ',.4)',
};
const qrBoxShadow = {
    boxShadow: '0 4px 20px 0 rgba(' + hexToRgb(blackColor) + ',.14), 0 7px 10px -5px rgba(' + hexToRgb(qrColor[0]) + ',.4)',
};
const greyBoxShadow = {
    boxShadow: '0 4px 20px 0 rgba(' + hexToRgb(blackColor) + ',.14), 0 7px 10px -5px rgba(' + hexToRgb(greyColor[3]) + ',.4)',
};

const warningCardHeader = {
    background: 'linear-gradient(60deg, ' + warningColor[1] + ', ' + warningColor[2] + ')',
    ...warningBoxShadow,
};
const successCardHeader = {
    background: 'linear-gradient(60deg, ' + successColor[1] + ', ' + successColor[2] + ')',
    ...successBoxShadow,
};
const dangerCardHeader = {
    background: 'linear-gradient(60deg, ' + dangerColor[1] + ', ' + dangerColor[2] + ')',
    ...dangerBoxShadow,
};
const infoCardHeader = {
    background: 'linear-gradient(60deg, ' + infoColor[1] + ', ' + infoColor[2] + ')',
    ...infoBoxShadow,
};
const primaryCardHeader = {
    background: 'linear-gradient(60deg, ' + primaryColor[1] + ', ' + primaryColor[2] + ')',
    ...primaryBoxShadow,
};
const dashboardCardHeader = {
    background: 'linear-gradient(60deg, ' + dashboardColor[1] + ', ' + dashboardColor[2] + ')',
    ...dashboardBoxShadow,
};
const leadsCardHeader = {
    background: 'linear-gradient(60deg, ' + leadsColor[1] + ', ' + leadsColor[2] + ')',
    ...leadsBoxShadow,
};
const fahrzeugeCardHeader = {
    background: 'linear-gradient(60deg, ' + fahrzeugeColor[1] + ', ' + fahrzeugeColor[2] + ')',
    ...fahrzeugeBoxShadow,
};
const kundenCardHeader = {
    background: 'linear-gradient(60deg, ' + kundenColor[1] + ', ' + kundenColor[2] + ')',
    ...kundenBoxShadow,
};
const einstellungenCardHeader = {
    background: 'linear-gradient(60deg, ' + einstellungenColor[1] + ', ' + einstellungenColor[2] + ')',
    ...einstellungenBoxShadow,
};
const qrCardHeader = {
    background: 'linear-gradient(60deg, ' + qrColor[1] + ', ' + qrColor[2] + ')',
    ...qrBoxShadow,
};
const greyCardHeader = {
    background: 'linear-gradient(60deg, ' + greyColor[8] + ', ' + greyColor[3] + ')',
    ...greyBoxShadow,
};

const card = {
    display: 'inline-block',
    position: 'relative',
    width: '100%',
    margin: '25px 0',
    boxShadow: '0 1px 4px 0 rgba(' + hexToRgb(blackColor) + ', 0.14)',
    borderRadius: '6px',
    color: 'rgba(' + hexToRgb(blackColor) + ', 0.87)',
    background: whiteColor,
};

const tooltip = {
    padding: '10px 15px',
    minWidth: '130px',
    color: whiteColor,
    lineHeight: '1.7em',
    background: 'rgba(' + hexToRgb(greyColor[6]) + ',0.9)',
    border: 'none',
    borderRadius: '3px',
    opacity: '1!important',
    boxShadow: '0 8px 10px 1px rgba(' + hexToRgb(blackColor) + ', 0.14), 0 3px 14px 2px rgba(' + hexToRgb(blackColor) + ', 0.12), 0 5px 5px -3px rgba(' + hexToRgb(blackColor) + ', 0.2)',
    maxWidth: '200px',
    textAlign: 'center',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '400',
    textShadow: 'none',
    textTransform: 'none',
    letterSpacing: 'normal',
    wordBreak: 'normal',
    wordSpacing: 'normal',
    wordWrap: 'normal',
    whiteSpace: 'normal',
    lineBreak: 'auto',
};

const title = (theme) => ({
    'color': theme?.palette?.text?.primary,
    'textDecoration': 'none',
    'fontWeight': '300',
    'marginTop': '30px',
    'marginBottom': '25px',
    'minHeight': '32px',
    'fontFamily': 'Roboto, Helvetica, Arial, sans-serif',
    '& small': {
        color: greyColor[1],
        fontSize: '65%',
        fontWeight: '400',
        lineHeight: '1',
    },
});

const cardTitle = (theme) => ({
    ...title(theme),
    'marginTop': '0',
    'marginBottom': '3px',
    'minHeight': 'auto',
    '& a': {
        ...title(theme),
        marginTop: '.625rem',
        marginBottom: '0.75rem',
        minHeight: 'auto',
    },
});

export {
    hexToRgb,
    // variables
    transition,
    container,
    boxShadow,
    card,
    defaultFont,
    primaryColor,
    warningColor,
    dangerColor,
    successColor,
    infoColor,
    dashboardColor,
    leadsColor,
    fahrzeugeColor,
    kundenColor,
    einstellungenColor,
    qrColor,
    internColor,
    supportColor,
    rateGreenColor,
    rateLightGreenColor,
    rateYellowColor,
    rateOrangeColor,
    rateRedColor,
    greyColor,
    blackColor,
    whiteColor,
    twitterColor,
    facebookColor,
    googleColor,
    linkedinColor,
    pinterestColor,
    youtubeColor,
    tumblrColor,
    behanceColor,
    dribbbleColor,
    redditColor,
    primaryBoxShadow,
    infoBoxShadow,
    successBoxShadow,
    warningBoxShadow,
    dangerBoxShadow,
    dashboardBoxShadow,
    leadsBoxShadow,
    fahrzeugeBoxShadow,
    kundenBoxShadow,
    einstellungenBoxShadow,
    qrBoxShadow,
    greyBoxShadow,
    warningCardHeader,
    successCardHeader,
    dangerCardHeader,
    infoCardHeader,
    primaryCardHeader,
    dashboardCardHeader,
    leadsCardHeader,
    fahrzeugeCardHeader,
    kundenCardHeader,
    einstellungenCardHeader,
    qrCardHeader,
    greyCardHeader,
    tooltip,
    title,
    cardTitle,
};
